import JobForm from "@container/job-form";
import AuthLayout from "@container/layout/auth";

export default function EmployerCreateJobPage() {
    return (
        <AuthLayout withoutHeader>
            <div className="relative">
                <JobForm />
            </div>
        </AuthLayout>
    )
}